import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { DialogUtilsComponent } from "./dialog-utils.component";

/**
 * Interfaz que agrupa el contenido del dialog y las funcionalidad de sus botones
 */
export interface ConfiguracionDialog {
  titulo?: string;
  mensaje?: string;
  success?: Function;
  reject?: Function;
  txtSuccess?: string;
  txtReject?: string;
  esTextoHtml?: boolean;
  panelClass?: string | string[];
}

export enum TiposModal {
  "warning" = 0,
  "error" = 1,
  "success" = 2,
  "confirm" = 3,
  "logout" = 4,
}

/**
 * Service que expone MatDialog, permite mediante sus diferentes
 * métodos abrir los cuatro tipo de dialog existentes:
 * Warning
 * Error
 * Success
 * Confirm
 * y configurar el contenido de los mismos
 */
@Injectable({
  providedIn: "root",
})
export class DialogUtilsService {
  dialogConfig = new MatDialogConfig();
  configuracionAltura: number = 3;
  configuracionAnchura: number = 3.2;

  constructor(
    public matDialog: MatDialog,
    private translate: TranslateService
  ) {
    this.configurarPorDefectoMatDialog();
  }

  abrirWarning(configuracion?: ConfiguracionDialog) {
    this.dialogConfig = new MatDialogConfig();
    this.configurarPorDefectoMatDialog();
    this.configurarPorDefecto(TiposModal.warning);
    if (configuracion) {
      this.rellenarDatos(configuracion);
    }
    const modalDialog = this.matDialog.open(
      DialogUtilsComponent,
      this.dialogConfig
    );
    modalDialog.afterClosed().subscribe(() => {
      this.configurarPorDefectoMatDialog();
    });
  }

  abrirError(configuracion?: ConfiguracionDialog) {
    this.dialogConfig = new MatDialogConfig();
    this.configurarPorDefectoMatDialog();
    this.configurarPorDefecto(TiposModal.error);
    if (configuracion) {
      this.rellenarDatos(configuracion);
    }
    const modalDialog = this.matDialog.open(
      DialogUtilsComponent,
      this.dialogConfig
    );
    modalDialog.afterClosed().subscribe(() => {
      this.configurarPorDefectoMatDialog();
    });
  }

  abrirSuccess(configuracion?: ConfiguracionDialog) {
    this.dialogConfig = new MatDialogConfig();
    this.configurarPorDefectoMatDialog();
    this.configurarPorDefecto(TiposModal.success);
    if (configuracion) {
      this.rellenarDatos(configuracion);
    }
    const modalDialog = this.matDialog.open(
      DialogUtilsComponent,
      this.dialogConfig
    );
    modalDialog.afterClosed().subscribe(() => {
      this.configurarPorDefectoMatDialog();
    });
  }

  abrirConfirm(configuracion?: ConfiguracionDialog) {
    this.dialogConfig = new MatDialogConfig();
    if(configuracion.panelClass) {
      this.dialogConfig.panelClass = configuracion.panelClass;
    }
    this.configurarPorDefectoMatDialog();
    this.configurarPorDefecto(TiposModal.confirm);
    if (configuracion) {
      this.rellenarDatos(configuracion);
    }
    const modalDialog = this.matDialog.open(
      DialogUtilsComponent,
      this.dialogConfig
    );
    modalDialog.afterClosed().subscribe(() => {
      this.configurarPorDefectoMatDialog();
    });
  }

  abrirLogout(configuracion?: ConfiguracionDialog) {
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.panelClass = 'new_style';
    this.configurarPorDefectoMatDialog();
    this.configurarPorDefecto(TiposModal.logout);
    if (configuracion) {
      this.rellenarDatos(configuracion);
    }
    const modalDialog = this.matDialog.open(
      DialogUtilsComponent,
      this.dialogConfig
    );
    modalDialog.afterClosed().subscribe(() => {
      this.configurarPorDefectoMatDialog();
    });
  }

  rellenarDatos(configuracion) {
    if (configuracion.titulo) {
      this.dialogConfig.data.titulo = configuracion.titulo;
    }
    if (configuracion.mensaje != null) {
      this.dialogConfig.data.mensaje = configuracion.mensaje;
    }
    if (configuracion.success != null) {
      this.dialogConfig.data.success = configuracion.success;
    }
    if (configuracion.reject != null) {
      this.dialogConfig.data.reject = configuracion.reject;
    }
    if (configuracion.txtSuccess != null) {
      this.dialogConfig.data.txtSuccess = configuracion.txtSuccess;
    }
    if (configuracion.txtReject != null) {
      this.dialogConfig.data.txtReject = configuracion.txtReject;
    }
    if (configuracion.panelClass != null) {
      this.dialogConfig.panelClass = configuracion.panelClass;
    }
    if (configuracion.esTextoHtml != null) {
      this.dialogConfig.data.esTextoHtml = configuracion.esTextoHtml;
    } else {
      this.dialogConfig.data.esTextoHtml = false;
    }
  }

  configurarPorDefectoMatDialog() {
    this.dialogConfig.disableClose = true;
    this.dialogConfig.id = "dialog-component-" + Math.random();
    this.dialogConfig.height =
      (screen.height / this.configuracionAltura).toString() + "px";
    this.dialogConfig.width =
      (screen.width / this.configuracionAnchura).toString() + "px";
    this.dialogConfig.data = {
      titulo: "",
      mensaje: "",
      success: null,
      reject: null,
      tipo: "",
    };
  }

  configurarPorDefecto(tipoModal: TiposModal) {
    this.translate
      .get("dialogUtils." + TiposModal[tipoModal] + ".titulo")
      .subscribe((titulo) => {
        this.dialogConfig.data.titulo = titulo;
      });
    this.translate
      .get("dialogUtils." + TiposModal[tipoModal] + ".mensaje")
      .subscribe((mensaje) => {
        this.dialogConfig.data.mensaje = mensaje;
      });
    this.dialogConfig.data.tipo = TiposModal[tipoModal];
  }
}
